import { render, staticRenderFns } from "./SendPasswordReset.vue?vue&type=template&id=322432b0&"
import script from "./SendPasswordReset.vue?vue&type=script&lang=js&"
export * from "./SendPasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports